import { UpdateIcon } from './UpdateIcon';

/**
 * author: Google
 * id 1B274396-AAE7-4CD8-8D57-27E31D915F68
 * name update
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/update.svg
 * tags
 * - Date / Time 
 */
export const ClockwiseIcon = UpdateIcon;
export default ClockwiseIcon